// removed by extract-text-webpack-plugin
module.exports = {"header__title":"header__title___25GtA","statistics":"statistics___1t2fQ","export":"export___2P6oW","table":"table___HqFhi","graphic":"graphic___3iWg2","graphicHide":"graphicHide___3bFi3","graphicHide__container":"graphicHide__container___2DSp9","filters":"filters___3ETQB","filters__displayType":"filters__displayType___1U3ir","loading":"loading___2WtDG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/Statistics.module.scss
// module id = 291
// module chunks = 0